import gas from "../../../img/Energy/Gas.png";
import power from "../../../img/Energy/Power.png";
import currency from "../../../img/Energy/Currency.png";
import carbon from "../../../img/Energy/Carbon.png";
import electricity from "../../../img/Energy/Electricity.png";
import forecasts from "../../../img/Energy/Forecasts.png";
import oil from "../../../img/Energy/Oil.png";

// import oil from "../../assets/img/energy/oil.svg";
// import coal from "../../assets/img/energy/coal.svg";
// import green from "../../assets/img/energy/green.svg";

const overviewCards = {
  gas: {
    title: "Gas",
    icon: gas,
    evolution: {
      arrow: 1,
      price: 41.24,
      origin: "TTF Spot",
      currency: "€/MWh",
      decimals: 2,
    },
  },
  power: {
    title: "Power",
    icon: power,
    evolution: {
      arrow: 1,
      price: 52.09,
      origin: "NL Spot",
      currency: "€/MWh",
      decimals: 2,
    },
  },
  carbon: {
    title: "Carbon",
    icon: carbon,
    evolution: {
      arrow: -1,
      price: 1.16,
      origin: "EUA Dec24",
      currency: "€/tonne",
      decimals: 4,
    },
  },
  currency: {
    title: "Currency",
    icon: currency,
    evolution: {
      arrow: 1,
      price: 1.16,
      origin: "EUR/USD",
      currency: "€/$",
      decimals: 4,
    },
  },
  electricity: {
    title: "Electricity",
    icon: electricity,
    evolution: {
      arrow: 1,
      price: 1.16,
      origin: "EUR/USD",
      currency: "€/$",
      decimals: 4,
    },
  },
  forecasts: {
    title: "Electricity",
    icon: forecasts,
    evolution: {
      arrow: 1,
      price: 1.16,
      origin: "EUR/USD",
      currency: "€/$",
      decimals: 4,
    },
  },
  oil: {
    title: "Oil",
    icon: oil,
    evolution: {
      arrow: 1,
      price: 1.16,
      origin: "EUR/USD",
      currency: "€/$",
      decimals: 4,
    },
  },
  //   oil: {
  //     title: "Brent Oil",
  //     icon: oil,
  //     evolution: {
  //       arrow: 1,
  //       price: 63.15,
  //       origin: "Brent M+1",
  //       currency: "$/bbl",
  //       decimals: 2,
  //     },
  //   },
  //   coal: {
  //     title: "Coal",
  //     icon: coal,
  //     evolution: {
  //       arrow: -1,
  //       price: 56.37,
  //       origin: "Coal ARA CIF Cal Y+1",
  //       currency: "$/tonne",
  //       decimals: 2,
  //     },
  //   },
  //   green: {
  //     title: "Carbon",
  //     icon: green,
  //     evolution: {
  //       arrow: -1,
  //       price: 41.17,
  //       origin: "EUA Dec 22",
  //       currency: "€/tonne",
  //       decimals: 2,
  //     },
  //   },
};

export default overviewCards;
